import React from "react";
import Logo from "../components/assets/logo-icon.png";

const About: React.FC = () => {
  return (
    <div className="home-page-container">
      <nav className="navbar">
        <div className="navbar-content">
          <img className="site-logo" src={Logo} alt="Cutter Games Logo" />
          <div className="site-header">
            <h1 className="site-title">Cutter Games</h1>
          </div>
          <ul className="nav-links">
            <li>
              <a href="/" className="nav-link">
                Home
              </a>
            </li>
            <li>
              <a href="/about" className="nav-link">
                About
              </a>
            </li>
            <li>
              <a href="/upload" className="nav-link">
                Upload
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <section className="results-list-section">
        <h1 className="section-title">About Cutter Games</h1>

        <p className="section-description">
          Cutter Games is a lightweight and intuitive leaderboard platform that
          gives athletes a way to measure their performance across a series of
          physical events. Designed to promote honesty, fairness, and consistent
          self-improvement, the site encourages lifelong fitness and friendly
          competition among athletes of all levels.
        </p>

        <p className="section-description">
          The platform is organized around three core pages: the{" "}
          <strong>Home</strong> page displays filtered leaderboards across all
          events, the <strong>Upload</strong> page allows athletes to submit
          their verified performances, and the <strong>About</strong> page
          offers background information and contact support. All submissions are
          reviewed and rely on an honor system to maintain fairness and
          integrity.
        </p>

        <p className="section-description">
          Cutter Games currently tracks performance in five events selected to
          measure strength, speed, and coordination:
        </p>
        <ul className="section-description">
          <li>
            <strong>Bench:</strong> One repetition of maximum-weight bench
            press.
          </li>
          <li>
            <strong>Squat:</strong> One repetition of maximum-weight back squat.
          </li>
          <li>
            <strong>Run:</strong> Fastest timed 1600 meter run.
          </li>
          <li>
            <strong>Swim:</strong> Fastest timed 100 yard swim.
          </li>
          <li>
            <strong>Shots:</strong> Most baskets made after thirty consecutive
            free throws.
          </li>
        </ul>

        <p className="section-description">
          At its core, Cutter Games is about cultivating a passion for athletics
          that lasts a lifetime. Whether you're training for competition or
          simply testing your limits, this platform gives you a place to track
          progress, stay motivated, and see how you stack up over time.
        </p>

        <p className="section-description">
          Technically, the site is built using React and Firebase. Athlete and
          performance data is stored securely in Firestore, and leaderboard
          filters update instantly based on user input. The design is fully
          responsive and optimized for mobile use, ensuring easy access from any
          device.
        </p>

        <p className="section-description">
          Cutter Games also supports <strong>leagues</strong> — private groups
          of athletes that can be created for schools, gyms, teams, or friend
          groups. If you'd like to start a league and track results within your
          own group, simply reach out to Christian using the contact information
          below.
        </p>

        <p className="section-description">
          If you have questions, want to join, or are interested in starting a
          league, reach out to:
        </p>
        <p className="section-description">
          <strong>Christian Cutter</strong>
          <br />
          Phone: 509-860-3228
          <br />
          Email: christianbcutter@yahoo.com
        </p>
      </section>
    </div>
  );
};

export default About;
